export default "__VITE_ASSET__Cssav_b1__"